/* パスワードリセット画面 */
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Block from '../../molecules/Block';
import Text from '../../molecules/Text';
import Annotation from '../../atoms/Annotation';
import CenterButton from '../../atoms/CenterButton';
import axios from '../../axios';
import { Button } from 'react-bootstrap';
import { handleBrowserBack } from '../../BrowserBack';
import LoadingModal from '../../molecules/LoadingModal';
import Dialog from '../../molecules/Dialog';

const PasswordReset: React.FC = () => {
  // 処理結果通知ダイアログ
  const [show, setShow] = useState(false);

  // メールアドレス
  const [email, setResetMail] = useState('');

  //ローディング画面表示状態
  const [is_loading, setIsLoading] = useState(false);

  // エラーメッセージ
  const [error_email, setErrorEmail] = useState('');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
  }, []);

  // パスワード変更ボタンのクリック
  const handleClick = async () => {
    try {
      setErrorEmail('');

      //ローディング画面表示
      setIsLoading(true);

      // 成功
      const response = await axios.post(
        `${location.origin}${process.env.MIX_MOCK_URL}/applicant/password/reset/send_mail`,
        { email: email }
      );

      if (response.data.result) {
        // ダイアログ表示
        setShow(true);
      } else {
        setErrorEmail(response.data.message.email);
      }
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    } finally {
      //ローディング画面非表示
      setIsLoading(false);
    }
  };

  // 完了ダイアログでOKをクリックしたらログイン画面へ遷移
  const handleClickOk = () => {
    setShow(false);
  };

  // 戻るボタンをクリックする
  const handleClickReturn = () => {
    location.replace(`${location.origin}${process.env.MIX_MOCK_URL}/mypage/login`);
  };

  // メールアドレス入力時の処理
  const handleChangeEmail = (value: string) => {
    setResetMail(value);
  };

  return (
    <>
      <Block
        label="パスワードリセット"
        content={
          <>
            <Annotation text="ご登録のメールアドレス (ログインID) にパスワードリセットのご案内をお送りします。" />
            <div>
              <Text
                id="email"
                label="メールアドレス"
                value={email}
                placeholder="example@example.com"
                handleChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                  handleChangeEmail(event.target.value)
                }
                disabled={false}
                maxlength={50}
                message={error_email}
                display_border={true}
              />
            </div>
            <div className="btn-group">
              <CenterButton label="パスワードリセットメールを送信する" handleClick={handleClick} />
              <div className="btn-left mt-5">
                <Button
                  variant="custom"
                  className="btn-large btn-white arrow-left-small"
                  size="lg"
                  onClick={handleClickReturn}
                >
                  戻る
                </Button>
              </div>
            </div>
          </>
        }
      />
      {/* モーダル */}
      <Dialog
        label="パスワードリセットのメール送信"
        body={<p>パスワードリセットのメールを送信しました。</p>}
        ok="閉じる"
        okCallback={handleClickOk}
        open={show}
        closeCallback={handleClickOk}
        ok_btn_class="btn-white"
      />
      {/* ローディング画面 */}
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('password-reset-imp')) {
  ReactDOM.render(<PasswordReset />, document.getElementById('password-reset-imp'));
}
